import styled from 'styled-components'
import { screenSizes } from '@shipt/design-system-themes'
import { NextLink } from '@/features/shared/elements/Link'
import { marketingStores } from '@/features/shared/constants/stores'
import { Image } from '@/features/shared/elements/Image/NextImage'
import { Row } from '@shipt/design-system-layouts'

export const StaticRetailerStoreGrid = () => (
  <Wrapper
    wrap
    justify="center"
    spacing={{ base: 'lg', lg: 'xl' }}
    margin={{ base: ['3xl', 'lg', 'sm'], md: ['3xl', 0, '4xl'] }}
  >
    {marketingStores.map(({ name, url, circular_image }) => (
      <NextLink href={url} key={name}>
        <StoreLogoWrapper>
          <Image
            src={circular_image}
            alt={`Get same-day delivery from ${name} with Shipt`}
            fill
            sizes="(max-width: 768px) 6.25rem, (max-width: 1200px) 8.125rem, 6rem"
          />
        </StoreLogoWrapper>
      </NextLink>
    ))}
  </Wrapper>
)

const Wrapper = styled(Row)`
  max-width: 1280px;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

const StoreLogoWrapper = styled.div`
  position: relative;
  height: 6rem;
  width: 6rem;
  margin-bottom: 1rem;

  @media ${screenSizes.tablet} {
    height: 6.25rem;
    width: 6.25rem;
    margin-bottom: 0.938rem;
  }

  @media ${screenSizes.smDesktop} {
    height: 8.125rem;
    width: 8.125rem;
  }
`
